var _defs, _polygon, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew296({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "11.88 7.61 2.43 2.15 2.43 13.06 11.88 7.61"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 13.57,
    y1: 1,
    x2: 13.57,
    y2: 15
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew296);
export default __webpack_public_path__ + "static/media/Symbolpack_New_296.b2ccb71d4a4b29c0fd3448bcc9181e3d.svg";
export { ForwardRef as ReactComponent };